import React from 'react';
import { FileSpreadsheet, Users, Calendar, MessageCircle, Dumbbell, CalendarDays } from 'lucide-react';
import { motion } from 'framer-motion';
const bonos = [{
  id: 'B1',
  icon: FileSpreadsheet,
  title: 'Pack de 30 Planillas de Sesión',
  desc: 'Llegá a cada entrenamiento con la práctica armada. 6 tipos distintos.',
  gradient: 'from-blue-500 to-blue-700'
}, {
  id: 'B2',
  icon: Users,
  title: 'Fichas de Evaluación por Posición',
  desc: 'Evaluá a cada jugador: golero, cierre, ala y pivote.',
  gradient: 'from-emerald-500 to-emerald-700'
}, {
  id: 'B3',
  icon: Calendar,
  title: 'Planilla de Asistencia y Carga Semanal',
  desc: 'Controlá quién viene, cuánto trabaja y cómo llega al partido.',
  gradient: 'from-purple-500 to-purple-700'
}, {
  id: 'B4',
  icon: MessageCircle,
  title: 'Guía de Charla Técnica',
  desc: 'Qué decir antes del partido. 8 situaciones distintas.',
  gradient: 'from-orange-500 to-red-600'
}, {
  id: 'B5',
  icon: Dumbbell,
  title: 'Banco de 50 Ejercicios y Drills',
  desc: '50 fichas listas para la cancha. 5 categorías, 3 niveles.',
  gradient: 'from-red-500 to-red-700'
}, {
  id: 'B6',
  icon: CalendarDays,
  title: 'Calendario Modelo de Temporada',
  desc: 'Planificá todo el año en menos de una hora. Fase a fase.',
  gradient: 'from-cyan-500 to-cyan-700'
}];
export function BonosGrid() {
  return <section className="py-10 md:py-16 bg-[#0F172A] px-4 relative" data-id="element-47">
      <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-48"></div>

      <div className="max-w-3xl mx-auto" data-id="element-49">
        <div className="text-center mb-5 md:mb-10" data-id="element-50">
          <span className="inline-block bg-gold text-dark font-bold px-3 md:px-4 py-1 rounded-full text-xs md:text-sm mb-2 md:mb-3 uppercase tracking-wider" data-id="element-51">
            INCLUIDOS GRATIS
          </span>
          <h2 className="font-display text-2xl md:text-4xl text-white mb-1 md:mb-2 uppercase" data-id="element-52">
            6 Bonos Estratégicos
          </h2>
          <p className="text-xs md:text-base text-gray-400 font-medium" data-id="element-53">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        {/* Horizontal compact rows with visual thumbnails */}
        <div className="space-y-2 mb-6 md:mb-8" data-id="element-54">
          {bonos.map((bono, i) => {
          const Icon = bono.icon;
          return <motion.div key={bono.id} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04,
            duration: 0.3
          }} className="group relative flex items-center gap-2.5 md:gap-3 bg-gray-800 border border-gray-700 hover:border-gold/60 rounded-lg pl-2 md:pl-2.5 pr-2.5 md:pr-3 py-2 md:py-2.5 transition-all duration-200 hover:bg-gray-800/80" data-id="element-55">
                {/* Visual thumbnail — gradient image-like block with icon */}
                <div className={`relative w-12 h-12 md:w-14 md:h-14 rounded-md bg-gradient-to-br ${bono.gradient} shrink-0 flex items-center justify-center overflow-hidden shadow-md`} data-id="element-56">
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.25),transparent_60%)]" data-id="element-57"></div>
                  <Icon className="text-white relative z-10 w-6 h-6 md:w-7 md:h-7" strokeWidth={2} data-id="element-58" />
                  {/* Tiny ID corner */}
                  <span className="absolute bottom-0 right-0 bg-black/40 text-gold font-display text-[8px] md:text-[9px] px-1 py-0 leading-tight rounded-tl-md" data-id="element-59">
                    {bono.id}
                  </span>
                </div>

                {/* Text */}
                <div className="flex-1 min-w-0" data-id="element-60">
                  <h3 className="font-bold text-white leading-tight text-sm md:text-base truncate" data-id="element-61">
                    {bono.title}
                  </h3>
                  <p className="text-[10px] md:text-xs text-gray-400 leading-snug mt-0.5 line-clamp-1 md:line-clamp-none" data-id="element-62">
                    {bono.desc}
                  </p>
                </div>

                {/* GRATIS badge */}
                <div className="bg-gold text-dark font-bold text-[9px] md:text-[10px] px-1.5 md:px-2 py-0.5 rounded shrink-0 uppercase tracking-wider shadow-sm" data-id="element-63">
                  GRATIS
                </div>
              </motion.div>;
        })}
        </div>

        <div className="bg-gold text-dark text-center py-2.5 md:py-3 rounded-lg font-display text-base md:text-xl uppercase tracking-wide shadow-[0_0_30px_rgba(245,185,33,0.2)]" data-id="element-64">
          VALOR TOTAL: $48.000 —{' '}
          <span className="text-white drop-shadow-md" data-id="element-65">GRATIS</span>
        </div>
      </div>
    </section>;
}